import {
  Flame,
  HeartPulse,
  LifeBuoy,
  HardHat,
  HandHelping,
  Network,
  GraduationCap,
  Check,
} from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const orgs = [
  { icon: Flame, label: "Feuerwehr" },
  { icon: HeartPulse, label: "Rettungsdienst" },
  { icon: LifeBuoy, label: "Katastrophenschutz" },
  { icon: HardHat, label: "Technisches Hilfswerk (THW)" },
  { icon: HandHelping, label: "Hilfsorganisationen" },
  { icon: Network, label: "Verbände" },
  { icon: GraduationCap, label: "Ausbildungsstätten im Rettungswesen" },
];

const roles = [
  "Führungskräfte",
  "Organisatorisch Verantwortliche",
  "Datenschutzbeauftragte",
  "Datenschutzkoordinatorinnen und -koordinatoren",
  "Hauptamtliche Führungskräfte",
  "Ehrenamtliche Führungskräfte",
  "Ausbilderinnen und Ausbilder",
  "Verantwortliche in Verbänden",
  "Personen, die mit personenbezogenen Daten arbeiten oder organisatorische Verantwortung tragen",
];

const Audiences = () => (
  <section
    id="zielgruppen"
    data-testid="audiences-section"
    className="py-24 sm:py-32"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHead
        overline="Zielgruppen"
        title="Für die gesamte Blaulichtfamilie."
      />

      <div className="mt-12 flex flex-wrap gap-3">
        {orgs.map((o, i) => (
          <Reveal key={o.label} delay={i * 0.06}>
            <div
              data-testid={`audience-org-${i + 1}`}
              className="card-glow flex items-center gap-3 rounded-full border border-white/10 bg-navy-800/70 px-5 py-3 transition-[border-color,transform] duration-300 hover:border-blau/50 hover:-translate-y-0.5"
            >
              <o.icon
                size={18}
                strokeWidth={1.8}
                className="text-blau-glow"
                aria-hidden="true"
              />
              <span className="text-sm font-medium text-gray-200">
                {o.label}
              </span>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <h3 className="mt-16 font-display text-xl sm:text-2xl font-bold text-white">
          Besonders relevant für
        </h3>
      </Reveal>
      <div className="mt-8 grid gap-x-10 gap-y-4 sm:grid-cols-2">
        {roles.map((r, i) => (
          <Reveal key={r} delay={Math.min(i * 0.05, 0.4)}>
            <div
              data-testid={`audience-role-${i + 1}`}
              className="flex items-start gap-3"
            >
              <Check
                size={18}
                className="mt-0.5 shrink-0 text-blau-glow"
                aria-hidden="true"
              />
              <span className="text-sm sm:text-base text-gray-300">{r}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Audiences;
